import { SubmitHandler } from 'react-hook-form'

import { usePostApiV1AccountsSignupMutation } from '../../../../authApi'

import { type RegisterInput } from './useForm'
import { useFinishSignup } from '../../hooks/useFinishSignup'
import { logger } from 'helpers/logger'
import trimObjectValues from 'helpers/trimObjectValues'
import { useParams } from 'react-router-dom'

export const fixedCacheKey = 'shared-data'
export const useSubmit = () => {
  const params = useParams()
  const { finishSignup } = useFinishSignup()
  const [registerUser, { isError, isLoading, isSuccess, error, data }] =
    usePostApiV1AccountsSignupMutation({ fixedCacheKey })

  const onSubmit: SubmitHandler<RegisterInput & { summary?: string }> = async (
    values,
  ) => {
    try {
      const trimmedValues = trimObjectValues(values)

      const res = await registerUser({
        accountCreate: {
          displayName: trimmedValues.displayName,
          username: trimmedValues.userName,
          email: trimmedValues.email.toLowerCase(),
          password: trimmedValues.password.replace(/\s+/g, ''),
          ...(params.inviteCode && { inviteCode: params.inviteCode }),
        },
      }).unwrap()
      await finishSignup({ ...res, email: trimmedValues.email })
    } catch (e) {
      logger.error(JSON.stringify(e))
    }
  }

  return { onSubmit, isLoading, isSuccess, error, isError, data }
}
